const HomeReferralSplash = require('./home-referral-splash.png')
const HomeReferralSplashLarge = require('./home-referral-splash-large.png')
const HorizontalDivider = require('./horizontal-divider.png')
const ProfileHeadshot = require('./profile-headshot.png')
const ProfileHeadshotLarge = require('./profile-headshot-large.png')
const VerticalDivider = require('./vertical-divider.png')
const GooglePlayStoreButton = require('./google-play-button.png')
const IosAppStoreButton = require('./ios-app-store-button.png')

export default {
	HomeReferralSplash,
	HomeReferralSplashLarge,
	HorizontalDivider,
	VerticalDivider,
	ProfileHeadshot,
	ProfileHeadshotLarge,
	GooglePlayStoreButton,
	IosAppStoreButton,
}
